import './select_input_component.scss'
import { Controller } from 'stimulus'
import * as Choices from 'choices.js'

export default class extends Controller {
  static targets = ['select']

  initialize = (): void => {
    if (this.select_input !== undefined) return
    this.select_input = new Choices(this.selectTarget, {
      searchFields: ['label'],
      removeItemButton: true,
      itemSelectText: '↵ Enter to select',
      placeholder: true,
      classNames: {
        containerOuter: 'select_input-input',
        containerInner: 'select_input-input__inner',
        input: 'select_input-input__input',
        inputCloned: 'select_input-input__input--cloned',
        list: 'select_input-input__list',
        listItems: 'select_input-input__list--multiple',
        listSingle: 'select_input-input__list--single',
        listDropdown: 'select_input-input__list--dropdown',
        item: 'select_input-input__item',
        itemSelectable: 'select_input-input__item--selectable',
        itemDisabled: 'select_input-input__item--disabled',
        itemOption: 'select_input-input__item--choice',
        placeholder: 'select_input__placeholder',
        group: 'select_input-input__group',
        groupHeading: 'select_input-input__heading',
        button: 'select_input-input__button',
        activeState: 'is-active',
        focusState: 'is-focused',
        openState: 'is-open',
        disabledState: 'is-disabled',
        highlightedState: 'is-highlighted',
        selectedState: 'is-selected',
        flippedState: 'is-flipped'
      }
    })
  }

  reset = (event: object): void => {
    this.select_input.removeActiveItems()
  }
}
